import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { deletePurchaseOrderApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const deletePurchaseOrder = createAsyncThunk('deletePurchaseOrder', async (payload) => {
  return await deletePurchaseOrderApi(payload);
});

const deletePurchaseOrderSlice = createSlice({
  name: 'deletePurchaseOrder', // Unique Name
  initialState,
  reducers: {
    deletePurchaseOrderReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(deletePurchaseOrder.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(deletePurchaseOrder.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(deletePurchaseOrder.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { deletePurchaseOrderReset } = deletePurchaseOrderSlice.actions;

export default deletePurchaseOrderSlice.reducer;
